import { router, IRouteEvent, Div } from '@codesuma/baseline'
import { Page } from '../../components/page'
import { PageHeader } from '../shared/page-header'
import { GoogleButton } from './google-button'
import { AppleButton } from './apple-button'
import services from '../../services'

export const LoginPage = () => {
    const base = Page()
    base.style({ backgroundColor: '#009187', color: '#fff' })
    const title = PageHeader('Login')
    const body = Div()
    body.style({
        padding: '20px',
        paddingTop: '120px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px'
    })

    // Sign in with Apple must be offered on iOS whenever Google is (Guideline 4.8),
    // and shown at least as prominently — so on iOS it goes first (solid button).
    const isIOS = (window as any).Capacitor?.getPlatform?.() === 'ios'
    if (isIOS) {
        const appleBtn = AppleButton()
        body.append(appleBtn)
        appleBtn.on('request-login', async () => {
            try {
                await services.supabase.auth.signInWithApple()
            } catch (e: any) {
                console.error(e)
                alert('Login failed: ' + (e?.message || e))
            } finally {
                appleBtn.reset()
            }
        })
    }

    const googleBtn = GoogleButton()
    body.append(googleBtn)

    base.append(title, body)

    googleBtn.on('request-login', async () => {
        try {
            await services.supabase.auth.signInWithGoogle()
        } catch (e: any) {
            console.error(e)
            alert('Login failed: ' + (e?.message || e))
        } finally {
            googleBtn.reset()
        }
    })

    const checkAuth = () => {
        if (services.supabase.auth.getUser()) {
            const redirect = (router.getQuery('redirect') as string) || '/'
            router.goto(redirect)
        }
    }

    // Subscribe to auth changes — needed for PKCE flow where code exchange
    // happens asynchronously after page load
    services.supabase.auth.subscribe((authState: any) => {
        if (authState.isAuthenticated) {
            checkAuth()
        }
    })

    base.on('enter', async () => {
        await services.supabase.auth.waitForInitialization()
        checkAuth()
    })

    return base
};
